// extracted by mini-css-extract-plugin
export default {"note":"note___f0cf405202ad9401"};